export default __webpack_public_path__ + "static/media/explore_destination_img3.274786a1.jpg";